// ProjectTeamItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'

class ProjectTeamItem extends Component {
  static get propTypes () {
    return {
      user: PropTypes.object,
      onDelete: PropTypes.func,
      onView: PropTypes.func,
      onChangePM: PropTypes.func,
      onRemovePM: PropTypes.func,
      showDelete: PropTypes.bool,
      isProjectManager: PropTypes.bool,
      isProjectManagerStatus: PropTypes.bool,
      totalUsers: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      user: {},
      onDelete: null,
      onView: null,
      onChangePM: null,
      onRemovePM: null,
      showDelete: false,
      isProjectManager: false,
      isProjectManagerStatus: false,
      totalUsers: 0
    }
  }

  render () {
    const {
      user,
      isProjectManager,
      showDelete,
      onDelete,
      isProjectManagerStatus,
      onRemovePM,
      totalUsers
    } = this.props
    const onClick = isProjectManager
      ? totalUsers >= 1
        ? onRemovePM
        : null
      : this._onChangePM

    return (
      <div className='project-teamitem' onClick={this._onClickView.bind(this)}>
        <div className='teamitem-content'>
          <div className='colavatar'>
            <Avatar imageUrl={user.imageUrl} />
          </div>
          <div className='colinfo'>
            <div className='username'>{user.displayName}</div>
          </div>
          {isProjectManagerStatus && (
            <div className='colpmstatus'>
              <div
                className={`status${isProjectManager ? ' active' : ''}`}
                onClick={onClick}
              >
                pm
              </div>
            </div>
          )}
          {showDelete && !isProjectManager && (
            <div className='itemhover'>
              <IconButton
                className='itemdelete'
                size='normal'
                canHover={false}
                icon='common-item-delete'
                onClick={onDelete}
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onClickView () {
    if (this.props.onView) {
      this.props.onView(this.props.user)
    }
  }

  _onChangePM = (e) => {
    const { onChangePM, user } = this.props
    e.preventDefault()

    if (onChangePM && user) {
      onChangePM(user)
    }
  };
}

export default ProjectTeamItem
